const getRelativeParent = (element: Element): Element => {
    if (!element) {
        return null;
    }

    const position = window.getComputedStyle(element).getPropertyValue("position");

    if (position !== "static") {
        return element;
    }

    return getRelativeParent(element.parentElement);
};

const getViewPort = (element: Element): Element => {
    if (!element) {
        return null;
    }

    const overflow = window.getComputedStyle(element).overflowY;
    if (overflow !== "visible") {
        return element;
    }

    return getViewPort(element.parentElement);
};

type Args = {
    decoratorRect: DOMRect;
    popover: HTMLDivElement;
};

export const positionSuggestions = ({ decoratorRect, popover }: Args) => {
    const editorContainer = getRelativeParent(popover.parentElement);
    const editorContainerRect = editorContainer.getBoundingClientRect();

    // should be scrollable part of task/project details
    // or messages container if opened inside message board dialog
    const viewPort = getViewPort(editorContainer.parentElement) || document.body;
    const viewPortRect = viewPort.getBoundingClientRect();

    let openAboveTarget = true;
    let yPos = decoratorRect.top;

    // if there is no space to open mentions popup above then target then
    // open it bellow
    if (yPos - popover.clientHeight < viewPortRect.top) {
        openAboveTarget = false;
        yPos = decoratorRect.bottom;
    }

    yPos = Math.max(editorContainerRect.top, yPos); // stick on editor's top border.
    yPos = Math.min(editorContainerRect.bottom, yPos); // stick on editor's bottom border.

    let xPos = decoratorRect.left;
    // stick on editor's right border
    xPos = Math.min(xPos, editorContainerRect.right - popover.offsetWidth);

    // move calculated YPos/XPos to absolute positions
    let top = "auto";
    let bottom = "auto";
    if (openAboveTarget) {
        bottom = `${editorContainerRect.bottom - yPos}px`;
    } else {
        top = `${yPos - editorContainerRect.top}px`;
    }
    const left = `${xPos - editorContainerRect.left}px`;

    return {
        left,
        top,
        bottom,
    };
};

export default positionSuggestions;
